angular.module('mtic.components.navbar')
.directive('navBarBackToModuleArrow', function (EventManager, MapStateService,$log,TeacherDataService) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarBackToModuleArrow', scope);
      var active = false;
          scope.status = {
            show: false

          }
          scope.closeResource = function () {
            scope.status.show = false;
            var focusedSlug = MapStateService.getFocusSlug();
            var activeModule = MapStateService.getActiveModule();
            eventManager.broadcast('module:change:meta', MapStateService.getMetaStateSlug());
            if(focusedSlug && focusedSlug.indexOf(activeModule) > -1){
              MapStateService.setFocusSlug("");
            }

            if(!TeacherDataService.isTeacherWorkspaceView){
              eventManager.broadcast("update:submodule:slug:route:name",{slug:"",name:""});
            }
          }
          eventManager.listen('module:change:submodule', function(e, data){
            scope.status.show = true;
            active = true;
            eventManager.broadcast('hide:back:arrow');
          })

          eventManager.listen('module:open:resource', function(e, data){
            scope.status.show = false;
          })

          eventManager.listen('module:close:resource', function(e, args){
            if (!(args && args.isPassive)){
              if(active){
                scope.status.show = true;
              }
            }
          });

          eventManager.listen('hide:back:module:arrow', function(e, data){
            scope.status.show = false;
          });
    }
  }
})
